export default {
  all: 'Todos',
  app_disabled: 'Estamos actualizando el contenido, volverá a estar disponible en breve',
  autocomplete_placeholder: 'Pon tu dirección o CP',
  back_to_list: 'Volver al listado',
  catalogue_image: 'Imagen del folleto',
  catalogue_loading: 'Estamos buscando tu catálogo',
  catalogues: 'Folletos',
  catalogues_in_area: 'Folletos cercanos',
  catalogues_loading: 'Cargando',
  catalogues_near_you: 'Folletos a tu alrededor',
  catalogues_not_found:
    'De momento no hay folletos en los alrededores, intenta introducir otra dirección o vuelve pronto para más ofertas',
  close_catalogues: 'Cerrar',
  close_products: 'Cerrar',
  close_stores: 'Cerrar',
  closed: 'Cerrado',
  characteristics: 'Características',
  days_of_week: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  description_missing: 'Ninguna descripción disponible',
  expires: 'Caduca',
  expired: 'Caducado',
  find_me: 'Encuéntrame',
  geolocation_error: 'Atención: la ubicación no ha dado resultados',
  geolocation_image: 'Geolocalización',
  geolocation_info:
    'Para enseñarte los catálogos en tu alrededor, necesitamos conocer tu ubicación. Pon tu dirección o CP',
  geolocation_loading: 'Estamos configurando tu ubicación',
  geolocation_missing: 'Actualiza tu ubicación para ver las ofertas y las tiendas más cercanas',
  localize_yourself: 'Ubícate',
  more_info: 'Descubre más',
  next: 'Siguiente',
  not_now: 'Ahora no',
  of: 'De',
  open: 'Abierto',
  open_24_hours: 'Abierto 24 horas',
  or: 'o bien',
  other_stores: 'Ofertas disponibles aquí también',
  page: 'Página',
  previous: 'Anterior',
  price: 'Precio',
  products: 'Productos',
  products_find: 'Busca un producto',
  index: 'Índice',
  products_list: 'Listado productos',
  read_all: 'Leer todo',
  sale: 'Descuento',
  search_placeholder: '¿Qué estás buscando?',
  stores: 'Tiendas',
  understand: 'Entendido',
  usergeolocation_label:
    'Pon tu dirección para encontrar las mejores ofertas de las tiendas en tu alrededor',
  fullscreen: 'Pantalla completa',
  fullscreenExit: 'Reduce pantalla',
  no_nearest_store_at: 'No hay tiendas cerca',
  nearest_store_at: 'Tienda más cercana en {distance}',
  nearby_stores: 'Tiendas alrededor',
  show_all_pages: 'Ver todas las páginas',
  show: 'Enseña',
  directionVertical: 'Scroll vertical',
  directionHorizontal: 'Scroll horizontal',
  share: 'Comparte',
  share_with_friends: 'Comparte con tus amigos',
  copy_link: 'Copia enlace',
  sms: 'SMS',
  email: 'email',
  more_stores: 'más tiendas',
  stores_within: 'Tiendas en un radio de {maxDistance}',
  invalid_offers_disclaimer:
    'Las ofertas de este catálogo no son válidas en las tiendas en tu alrededor, consulta otro catálogo o ubícate en otra zona.',
  download_pdf: 'Descarga PDF',
  available_options: 'Disponible en {numOptions} opciones:',
  flyer_unavailable_error:
    'No es posible abrir este catálogo. Comprueba el enlace o inténtalo de nuevo más tarde.',
};
